itsoftApp.createModule("lottie", function () {
    const module = this;

    const Lottie = function (container) {
        this.container = container;
        this.library = '/assets/scripts/lottie-player-0.4.0.min.js';
        this.json = '/media/lottie/clock.json';
        this.el = this.container.querySelector("lottie-player");

        this.init();
    };
    Lottie.prototype.play = function() {
        this.el.classList.add('_loaded');
        this.el.play();
    }
    Lottie.prototype.loadEl = function() {
        this.el.load(this.json);
        this.el.addEventListener("load", this.play);
    }
    Lottie.prototype.loadLib = function() {
        itsoftApp.loadScript(this.library, this.loadEl);
    }
    Lottie.prototype.bindEvents = function() {
        this.play = this.play.bind(this);
        this.loadEl = this.loadEl.bind(this);
    }
    Lottie.prototype.init = function() {
        this.bindEvents();
        this.loadLib();
    }

    module.callback = Lottie;
});